import { PlaceType, RoomType } from 'src/types';

import { client } from './client';
import { Building, Floor, SortDirection, Town } from './types';

export interface LastBooking {
  building: Building;
  placeId: number;
  placeType: PlaceType;
  floor: Floor;
  town: Town;
}

export interface LastBookingsCreatedResponse {
  lastBookingsCreated: LastBooking[];
}

export const lastBookingsCreated = async (
  employeeNumber: string,
): Promise<LastBooking[]> => {
  try {
    const response = await client.get<LastBookingsCreatedResponse>(
      `/api/v2/bookings/lastBookingsCreated/${employeeNumber}`,
    );
    return response.data.lastBookingsCreated;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export interface BookingInfo {
  bookingId: string;
  created: string;
  placeId: number;
  placeTitle: string;
  placeType: PlaceType;
  roomType: RoomType | null;
  floor: Floor;
  town: Town;
  building: Building;
  bookedFrom: string;
  bookedTo: string;
  responsible: string | null;
}

export interface FindBookingsParams {
  offset?: number;
  from?: string;
  limit?: number;
  deleted?: boolean;
  sortField?: string;
  sortDirection?: SortDirection;
  searchFrom?: string;
  searchTo?: string;
  filterPlaceType?: PlaceType;
  filterRoomType?: RoomType;
  filterEmployeeNumber?: string;
  filterAuthorEmployeeNumber?: string;
  bookedToAfter?: string;
  bookedToBefore?: string;
}

export interface FindBookingsResponse {
  bookings: BookingInfo[];
  nextPageToken: string | null;
}

export const findBookings = async (
  params: FindBookingsParams,
): Promise<FindBookingsResponse> => {
  try {
    const response = await client.get<FindBookingsResponse>(
      '/api/v2/bookings',
      {
        params,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};
